'use client';

import { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function ThemeToggle() {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    if (typeof window === 'undefined') return 'light';
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') return stored;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [theme]);

  // Sync on mount in case SSR had different default
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') {
      setTheme(stored);
    }
  }, []);

  const toggle = () => setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <button data-component-id="components/common/ThemeToggle.tsx:36:4" data-component-path="components/common/ThemeToggle.tsx" data-component-line="36" data-component-file="ThemeToggle.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22p-2%20rounded-lg%20hover%3Abg-surface%2F80%20transition-fast%20border%20border-transparent%20hover%3Aborder-primary%2F20%22%7D"
      aria-label="Toggle theme"
      onClick={toggle}
      className="p-2 rounded-lg hover:bg-surface/80 transition-fast border border-transparent hover:border-primary/20"
    >
      {theme === 'dark' ? (
        <Icon data-component-id="components/common/ThemeToggle.tsx:42:8" data-component-path="components/common/ThemeToggle.tsx" data-component-line="42" data-component-file="ThemeToggle.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SunIcon%22%2C%22className%22%3A%22text-yellow-400%22%7D" name="SunIcon" size={20} className="text-yellow-400" />
      ) : (
        <Icon data-component-id="components/common/ThemeToggle.tsx:44:8" data-component-path="components/common/ThemeToggle.tsx" data-component-line="44" data-component-file="ThemeToggle.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MoonIcon%22%2C%22className%22%3A%22text-slate-600%22%7D" name="MoonIcon" size={20} className="text-slate-600" />
      )}
    </button>
  );
}
